import { __assign, __awaiter, __generator, __read, __spreadArray } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { createStaleWhileRevalidateOperation, } from '@office-start/persistence-strategies';
import { PotentialActionType, } from '@office-start/recommended-types';
import { readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { UnreactiveActionCreators } from '@office-start/toast-utility';
import { addFilesActionsInternal, } from '../addFilesActionsInternal';
import { officeFeedPersistenceKey, recommendedPersistenceVersion, } from '../constants';
import { fetchFileTypes } from '../getFileTypes';
import { getQueryKey } from '../getQueryKey';
import { getSources } from '../getSources';
import { createPersistenceKey, createPersistencePluginsForWrite, removeItemFromPersistence, } from '../util/persistenceUtilities';
import { fetchFeedApiData } from './fetchFeedApiData';
import { parseRawFeedApiDataToRecommendedData } from './parseRawFeedApiDataToRecommendedData';
import { performActionsInternal } from './performActionsInternal';
import { postFeedbackInstrumentationInternal } from './postFeedbackInstrumentationInternal';
import { removeDocumentInternal } from './removeDocumentInternal';
function getOfficeFeedApiDataProvider(props) {
    var _this = this;
    var identity = props.identity, officeComponentContext = props.officeComponentContext, recommendedConfig = props.recommendedConfig, encryptionKeyResult = props.encryptionKeyResult;
    var options = {
        correlationId: officeComponentContext.correlationId,
        jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
        filesPath: recommendedConfig.filesPath,
        getAccessToken: officeComponentContext.getAccessToken,
        numItemsToRequest: recommendedConfig.numItemsToRequest,
        substrateApi: recommendedConfig.substrateApi,
        rootPath: recommendedConfig.officeFeedApiRootPath,
        inMockMode: !!officeComponentContext.inMockMode,
        officeApiRoot: officeComponentContext.officeHomeApiRoot,
        officeMarket: officeComponentContext.preferredCulture,
        substrateAppId: recommendedConfig.substrateAppId,
        aadClientId: officeComponentContext.aadAppId,
        objectId: identity.objectId,
        tenantId: identity.tenantId,
    };
    var getRecommendedData = function (fileType, query) {
        // TODO: this is a temporary workaround for fetching stream recommended. Should be removed after the value is from config
        var fileTypes = fetchFileTypes(fileType, recommendedConfig.pdfEnabled, recommendedConfig.upcomingMeetingEnabled, recommendedConfig.visioEnabled);
        var fetchOptions = __assign(__assign({}, options), { fileTypes: fileTypes, sources: getSources() });
        var handleRevalidation = function (freshData) {
            return queryCache.setQueryData(query, freshData);
        };
        return createStaleWhileRevalidateOperation(function () { return fetchFeedApiData(fetchOptions); }, function () {
            var plugins = createPersistencePluginsForWrite(encryptionKeyResult);
            // Reverse order of plugins used for write so they play back
            // in the correct order.
            var pluginsForRead = __spreadArray([], __read(plugins), false).reverse();
            return readFromSimplePersistence({
                userId: identity.puid,
                collectionName: officeFeedPersistenceKey,
                collectionVersion: recommendedPersistenceVersion,
                key: createPersistenceKey(fileTypes, officeFeedPersistenceKey),
                plugins: pluginsForRead,
            });
        }, function (networkPayload) { return __awaiter(_this, void 0, void 0, function () {
            var plugins;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        plugins = createPersistencePluginsForWrite(encryptionKeyResult);
                        return [4 /*yield*/, writeToSimplePersistence({
                                userId: identity.puid,
                                collectionName: officeFeedPersistenceKey,
                                collectionVersion: recommendedPersistenceVersion,
                                key: createPersistenceKey(fileTypes, officeFeedPersistenceKey),
                                data: networkPayload,
                                plugins: plugins,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, handleRevalidation, function (rawData) {
            return parseRawFeedApiDataToRecommendedData(rawData, officeComponentContext.preferredCulture);
        });
    };
    var addFilesActions = function (request) {
        return addFilesActionsInternal(request, __assign(__assign({}, options), { filesActionsPath: recommendedConfig.filesActionsPath }), true);
    };
    var removeDocument = function (props) {
        var removeOptions = __assign(__assign({}, options), { dismissedDocumentsPath: 'peoplepredictionsb2/Feedback' });
        return removeDocumentInternal(removeOptions, props.feedbackId);
    };
    var returnCorrectDoc = function (doc, removeDocId) {
        if (doc && doc.id === removeDocId) {
            return;
        }
        if (doc.items) {
            //if the doc is a composite item, perform filter function on inner items and return that new doc
            var compositeItem = doc;
            compositeItem.items =
                compositeItem.items &&
                    compositeItem.items.filter(function (innerDoc) {
                        return innerDoc && innerDoc.id !== removeDocId;
                    });
            if (compositeItem.items && compositeItem.items.length !== 0) {
                return compositeItem;
            }
            else {
                return;
            }
        }
        return doc;
    };
    var onRemoveSuccessCallback = function (props, _queryKey) {
        // Make sure the document is removed in all queries.
        // For example, a powerpoint file existed in these queries: ["RecommendedData", "MicrosoftFeedApi"], ["RecommendedData", "MicrosoftFeedApi", "PowerPoint"]
        var queries = [];
        var queryOfAllDocs = getQueryKey('MicrosoftFeedApi');
        queries.push(queryOfAllDocs);
        if (props.docFileType) {
            var queryOfFileType = getQueryKey('MicrosoftFeedApi', props.docFileType);
            queries.push(queryOfFileType);
        }
        queries.forEach(function (query) {
            queryCache.cancelQueries(query);
            var previousValue = queryCache.getQueryData(query);
            if (!(previousValue === null || previousValue === void 0 ? void 0 : previousValue.result)) {
                return;
            }
            var newDocuments = previousValue.result.documents.map(function (doc) {
                return returnCorrectDoc(doc, props.docId);
            });
            var newValue = {
                result: {
                    documents: newDocuments.filter(function (doc) {
                        return doc !== undefined;
                    }),
                    diagnosticData: previousValue.result.diagnosticData,
                },
                fromPersistence: previousValue.fromPersistence,
            };
            queryCache.setQueryData(query, newValue);
        });
        removeItemFromPersistence({
            docProps: props,
            isOfficeFeed: true,
            pdfEnabled: recommendedConfig.pdfEnabled,
            upcomingMeetingEnabled: recommendedConfig.upcomingMeetingEnabled,
            visioEnabled: recommendedConfig.visioEnabled,
            encryptionKeyResult: encryptionKeyResult,
            identity: identity,
            persistenceKey: officeFeedPersistenceKey,
        });
    };
    var onRemoveErrorCallback = function (_props) {
        // TODO: add telemetry
    };
    var performActions = function (props) {
        return performActionsInternal(options, props.feedbackId, props.actionType, props.payload);
    };
    var onPerformActionsSuccessCallback = function (props, _queryKey) {
        props.setPrimaryAction && props.setPrimaryAction();
        props.actionType === PotentialActionType.PromoteTask
            ? props.onViewToDoClick &&
                UnreactiveActionCreators.createSuccessNotification('Added to ToDo', {
                    onClick: props.onViewToDoClick,
                    label: 'Open',
                })
            : props.actionType === PotentialActionType.MarkTaskAsDone
                ? UnreactiveActionCreators.createSuccessNotification('Marked task as done')
                : null;
    };
    var onPerformActionsErrorCallback = function (props) {
        props.actionType === PotentialActionType.PromoteTask
            ? UnreactiveActionCreators.createErrorNotification('Unable to add To Do')
            : props.actionType === PotentialActionType.MarkTaskAsDone
                ? UnreactiveActionCreators.createErrorNotification('Unable to mark task as done')
                : null;
    };
    var postFeedbackInstrumentation = function (props) {
        postFeedbackInstrumentationInternal(options, props);
    };
    return {
        addFilesActions: addFilesActions,
        getRecommendedData: getRecommendedData,
        removeDocument: removeDocument,
        onRemoveSuccessCallback: onRemoveSuccessCallback,
        onRemoveErrorCallback: onRemoveErrorCallback,
        performActions: performActions,
        onPerformActionsSuccessCallback: onPerformActionsSuccessCallback,
        onPerformActionsErrorCallback: onPerformActionsErrorCallback,
        postFeedbackInstrumentation: postFeedbackInstrumentation,
    };
}
export { getOfficeFeedApiDataProvider as getDataManager };
//# sourceMappingURL=getOfficeFeedApiDataProvider.js.map